import { call, put, select, takeLatest } from 'redux-saga/effects'
import { setSavePcsInformationResponse } from '../store/pcsInformation.actions'
import { IPcsInformationState } from '../store/pcsInformation.types'
import { PcsInformationConstants } from '../store/pcsInformation.constants'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { getPcrIdSelector } from '../../home/selectors'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcsInformationSelector } from '../selectors'
import { IPcr } from '../../pcr/store/pcr.types'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { setHasPatient } from '../../patientInformation/store/patientInformation.actions'

export function* savePCSInformation() {
  const pcsInformation: IPcsInformationState = yield select(getPcsInformationSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      billing: {
        ...pcrDoc.billing,
        pcsInformation: { ...pcsInformation },
      },
    }
    try {
      yield put(setHasPatient(true))
      const response: string = yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
      yield put(setSavePcsInformationResponse(response))
    } catch (e) {
      yield put(throwPcrException(`savePCSInformation() error: ${e}`))
    }
  }
}
export function* savePCSInformationSaga() {
  yield takeLatest([PcsInformationConstants.SAVE_PCSINFORMATION], performWithMutexHOG, savePCSInformation)
}
